import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PopUpModel } from './pop-up.model';
import { MarkdownToHtmlConverter } from '../misc-utils/markdown-to-html-converter';

@Component({
  selector: 'app-pop-up-onboarding',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss'],
})
export class PopUpComponent implements OnInit {
  title = '';

  message = '';

  markdownBody?: string;

  rawMarkdown?: string;

  messageParams = {};

  list: string[] | undefined;

  okColour = 'accent';

  okText = 'common.ok';

  cancelText: string | undefined;

  showCloseButton: boolean;

  roundButton?: boolean;

  layoutAlign = 'end bottom';

  constructor(
    public dialogRef: MatDialogRef<PopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PopUpModel,
    private ngZone: NgZone,
  ) {
    this.title = data.title;
    this.layoutAlign = data.layoutAlign || 'end bottom';
    this.message = data.message;
    this.messageParams = data.messageParams || {};
    this.cancelText = data.cancelText;
    this.list = data.list;
    this.showCloseButton = !!data.showCloseButton;
    this.roundButton = !!data.roundButton;

    if (data.okText) {
      this.okText = data.okText;
    }

    if (data.okColour) {
      this.okColour = data.okColour;
    }

    this.rawMarkdown = data.rawMarkdown;
  }

  async ngOnInit(): Promise<void> {
    if (this.rawMarkdown) {
      this.markdownBody = await MarkdownToHtmlConverter.markdownToHtml(this.rawMarkdown);
    }
  }

  onClose(): void {
    this.ngZone.run(() => {
      this.dialogRef.close(false);
    });
  }

  onYesClick(): void {
    this.ngZone.run(() => {
      this.dialogRef.close(true);
    });
  }
}
